import { useDynamicModalContext } from "@umami/components";
import {
  decryptSeedphrasesAndSecretkeys,
  useAppSelector,
  useAsyncActionHandler,
  useDownloadBackupFile,
} from "@umami/state";

import { usePasskey } from "../../../hooks/usePasskey";
import { MasterPasswordModal } from "../../MasterPasswordModal";

import { SetupBackupPassword } from "@/components/SetupBackupPassword";

export const useHandleSaveBackup = () => {
  const accounts = useAppSelector(state => state.accounts);
  const saveBackup = useDownloadBackupFile();
  const { isPasskeyFlow, authenticate, isLoading, isPasskeyUser } = usePasskey();
  const { openWith } = useDynamicModalContext();
  const { handleAsyncAction } = useAsyncActionHandler();

  const handleSaveBackup = async () => {
    const onSubmitNewPassword = async ({
      currentPassword,
      backupPassword,
      onClose,
    }: {
      currentPassword: string;
      backupPassword: string;
      onClose: () => void;
    }) =>
      handleAsyncAction(async () => {
        if (currentPassword && backupPassword) {
          await saveBackup({ currentPassword, backupPassword });
          onClose();
        }
      });

    const onCurrentPassword = async (currentPassword?: string) =>
      handleAsyncAction(async () => {
        if (!currentPassword) {
          return;
        }

        // Check if the current password is correct
        await decryptSeedphrasesAndSecretkeys({
          password: currentPassword,
          accounts,
        });

        await openWith(
          <SetupBackupPassword
            isSetNewPassword
            onSubmit={(backupPassword, onClose) =>
              onSubmitNewPassword({ currentPassword, backupPassword, onClose })
            }
          />
        );
      });

    if (isPasskeyFlow && isPasskeyUser) {
      const { dek: password } = await authenticate();

      if (password) {
        await onCurrentPassword(password);
      }
    } else {
      await openWith(
        <MasterPasswordModal
          isLoading={isLoading}
          onSubmit={onCurrentPassword}
          submitButtonText="Confirm"
        />
      );
    }
  };

  return handleSaveBackup;
};
